/** Экран выводится из статуса проекта и параметра запуска — роутера нет. */
import type { Screen, State } from './store';

export type StartTarget = { projectId: string } | { screen: 'balance' };

/** Диплинк проекта или оплаты из startapp. */
export function parseStartParam(param: string | undefined): StartTarget | null {
  if (!param) return null;
  if (param.trim() === 'balance') return { screen: 'balance' };
  const match = /^project[_-](.+)$/.exec(param.trim());
  if (!match) return null;
  const projectId = match[1];
  return projectId && projectId.length > 0 ? { projectId } : null;
}

export function deriveScreen(state: State): Screen {
  if (state.route) return state.route;
  const project = state.project;
  if (!project) return state.onboardingSeen ? 'editor' : 'onboarding';
  switch (project.status) {
    case 'draft':
      return 'editor';
    case 'uploading':
    case 'transcribing':
    case 'analyzing':
    case 'planning':
    case 'rendering':
    case 'delivering':
    case 'failed':
      return 'progress';
    case 'done':
    case 'expired':
      return 'result';
    default:
      return 'editor';
  }
}
